const $teaserScroller = $('.js-simple-scroller');
$teaserScroller.simpleScroller({
    dur: 600,
    auto: false,
    pause: 4000,
    counter: true,
    numbers: true,
    numbers_divisor: ' von ',
    skip: 0,
    dir: 'horizontal',
    align: 'left',
    onswipe: 'animate',
    hover: false
});
// Verhindert, dass der Link durch den Mausklick fokussiert wird
// und die Slide-Elemente bei Klíck verschieben
$teaserScroller.on('mousedown', 'a', function (event) {
    event.preventDefault();
});